import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { AITranslationModel, AITranslationModelImpl } from './model/ai-translation.model';
import { AITranslationService, AITranslationServiceImpl } from './service/ai-translation.service';
import { OriginalInputModel, OriginalInputModelImpl } from './model/original-input.model';
import { OriginalInputService, OriginalInputServiceImpl } from './service/original-input.service';
import { SuggestionModel, SuggestionModelImpl } from './model/suggestion.model';
import { SuggestionService, SuggestionServiceImpl } from './service/suggestion.service';
import { StreamService } from '@/services/ai-translation/service/stream.service.interface'
import { SectionTypewriterServiceImpl } from '@/services/ai-translation/service/section-typewriter.service';
import { TranslationGeneratorSyncServiceImpl } from '@/services/ai-translation/service/translation-generator-sync.service';
import { TranslationGeneratorAsyncService, TranslationGeneratorAsyncServiceImpl } from '@/services/ai-translation/service/translation-generator-async.service';
import { TranslationResultService, TranslationResultServiceImpl } from '@/services/ai-translation/service/translation-result.service';
import { CheckSensitiveWordDTO, GetTechTopicDTO, GetSuggestionsDTO, AddTranslationAsyncTaskDTO, GetTranslationAsyncStatusDTO, PutTranslationTextDTO, ExportTranslationDTO, TranslationSyncDTO, TranslationOriginalDTO } from './service/ai-translation.repository.interface';
import { CheckSensitiveWordDTOImpl } from './repository/check-sensitive-word.dto';
import { GetTechTopicDTOImpl } from './repository/get-tech-topic.dto';
import { GetSuggestionsDTOImpl } from './repository/get-suggestions.dto';
import { AddTranslationAsyncTaskDTOImpl } from './repository/add-translation-async-task.dto';
import { GetTranslationAsyncStatusDTOImpl } from './repository/get-translation-async-status.dto';
import { PutTranslationTextDTOImpl } from './repository/put-translation-text.dto';
import { ExportTranslationDTOImpl } from './repository/export-translation.dto';
import { TranslationSyncDTOImpl } from './repository/translation-sync.dto';
import { TranslationOriginalDTOImpl } from './repository/translation-original.dto';

export const aiTranslationModule = (bind: interfaces.Bind) => {
    bind(OriginalInputModel).to(OriginalInputModelImpl);
    bind(OriginalInputService).to(OriginalInputServiceImpl);
    bind(AITranslationModel).to(AITranslationModelImpl);
    bind(AITranslationService).to(AITranslationServiceImpl);
    bind(SuggestionModel).to(SuggestionModelImpl);
    bind(SuggestionService).to(SuggestionServiceImpl);
    bind(StreamService).to(SectionTypewriterServiceImpl).whenTargetNamed('SectionTypewriterService');
    bind(StreamService).to(TranslationGeneratorSyncServiceImpl).whenTargetNamed('TranslationGeneratorSyncService');
    bind(TranslationGeneratorAsyncService).to(TranslationGeneratorAsyncServiceImpl);
    bind(TranslationResultService).to(TranslationResultServiceImpl);

    bind(CheckSensitiveWordDTO).to(CheckSensitiveWordDTOImpl);
    bind(GetTechTopicDTO).to(GetTechTopicDTOImpl);
    bind(GetSuggestionsDTO).to(GetSuggestionsDTOImpl);
    bind(AddTranslationAsyncTaskDTO).to(AddTranslationAsyncTaskDTOImpl);
    bind(GetTranslationAsyncStatusDTO).to(GetTranslationAsyncStatusDTOImpl);
    bind(PutTranslationTextDTO).to(PutTranslationTextDTOImpl);
    bind(ExportTranslationDTO).to(ExportTranslationDTOImpl);
    bind(TranslationSyncDTO).to(TranslationSyncDTOImpl);
    bind(TranslationOriginalDTO).to(TranslationOriginalDTOImpl);
};
